import { render, staticRenderFns } from "./shop-order.vue?vue&type=template&id=61ee3fde&scoped=true"
import script from "./shop-order.vue?vue&type=script&lang=js"
export * from "./shop-order.vue?vue&type=script&lang=js"
import style0 from "./shop-order.vue?vue&type=style&index=0&id=61ee3fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ee3fde",
  null
  
)

export default component.exports